import { classNames } from 'uitk-react-utils';
import styles from './uitk-progress-indicator.css';
var getClassNameList = classNames.bind(styles);
var applyFade = function (target) {
  if (!target) {
    return;
  }
  var maxScrollLeft = target.scrollWidth - target.clientWidth;
  var targetAbsoluteScroll = Math.abs(target.scrollLeft);
  if (targetAbsoluteScroll >= maxScrollLeft - 10) {
    target.classList.add(getClassNameList('unfade-end'));
    target.classList.remove(getClassNameList('fade-end'));
  } else {
    target.classList.add(getClassNameList('fade-end'));
    target.classList.remove(getClassNameList('unfade-end'));
  }
  if (targetAbsoluteScroll <= 10) {
    target.classList.remove(getClassNameList('fade-start'));
    target.classList.remove(getClassNameList('fade-end'));
  } else {
    target.classList.add(getClassNameList('fade-start'));
  }
};
var getOffsetNeededToCenterStep = function (stepList, stepElement) {
  var stepOffset = stepElement.offsetLeft;
  var progressIndicatorCenterOffset = stepList.getBoundingClientRect().width / 2;
  var stepCenterOffset = stepElement.getBoundingClientRect().width / 2;
  return stepOffset - progressIndicatorCenterOffset + stepCenterOffset;
};
export { applyFade, getOffsetNeededToCenterStep };